<template>
  <div>
    <div style="width: 100%;height: 32px;"></div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
       <el-form-item label="开票接口地址：" prop="invoiceDomain">
          <el-input style="width: 424px;" v-model="ruleForm.invoiceDomain" placeholder="请输入开票接口地址"></el-input>
        </el-form-item>
        <el-form-item label="3DES密钥：" prop="invoiceDesKey">
          <el-input style="width: 424px;" v-model="ruleForm.invoiceDesKey" placeholder="请输入3DES密钥"></el-input>
          <div class="mt-system-warm">说明：票通提供</div>
        </el-form-item>
        <el-form-item label="平台简称：" prop="invoicePlatformAlias">
          <el-input style="width: 424px;" v-model="ruleForm.invoicePlatformAlias" placeholder="请输入平台简称"></el-input>
          <div class="mt-system-warm">说明：票通提供</div>
        </el-form-item>
        <el-form-item label="平台编码：" prop="invoicePlatformCode">
          <el-input style="width: 424px;" v-model="ruleForm.invoicePlatformCode" placeholder="请输入平台编码"></el-input>
          <div class="mt-system-warm">说明：票通提供</div>
        </el-form-item>
        <el-form-item label="私钥：" prop="invoicePrivateKey">
          <el-input style="width: 424px;" v-model="ruleForm.invoicePrivateKey" placeholder="请输入私钥"></el-input>
          <div class="mt-system-warm">说明：票通提供</div>
        </el-form-item>
        <el-form-item label="公钥：" prop="invoicePublicKey">
          <el-input style="width: 424px;" v-model="ruleForm.invoicePublicKey" placeholder="请输入公钥"></el-input>
          <div class="mt-system-warm">说明：票通提供</div>
        </el-form-item>
        <el-form-item label="纳税人识别号：" prop="invoiceTaxpayerNum">
          <el-input style="width: 424px;" v-model="ruleForm.invoiceTaxpayerNum" placeholder="请输入纳税人识别号"></el-input>
          <div class="mt-system-warm">说明：销售方税号</div>
        </el-form-item>
        <el-form-item label="税率：" prop="invoiceTaxRate">
          <el-input style="width: 424px;" v-model="ruleForm.invoiceTaxRate" placeholder="请输入税率"></el-input>
          <div class="mt-system-warm">注：金税三期之后不存在16%与10%税率，16%自动降为13%，10%自动降为9%</div>
        </el-form-item>
        <el-form-item label="税收分类编码：" prop="invoiceTaxClassificationCode">
          <el-input style="width: 424px;" v-model="ruleForm.invoiceTaxClassificationCode" placeholder="请输入税收分类编码"></el-input>
          <div class="mt-system-warm">说明：可以按照Excel文档填写</div>
        </el-form-item>
      <el-form-item>
        <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { saveOrUpdateShopConfig, fetchShopConfigDetail } from '@/api/shop'
export default {
  name: 'Invoice',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      ruleForm: {
         invoiceDomain:'',
         invoiceDesKey:'',
         invoicePlatformAlias:'',
         invoicePlatformCode:'',
         invoicePrivateKey:'',
         invoicePublicKey:'',
         invoiceTaxpayerNum:'',
         invoiceTaxRate:'',
         invoiceTaxClassificationCode:''
      },
      rules: {
        invoiceDomain: [
          { required: true, message: '请输入核销人名称', trigger: 'blur' }
        ],
        invoiceDesKey: [
          { required: true, message: '请输入3DES密钥', trigger: 'blur' }
        ],
        invoicePlatformAlias: [
          { required: true, message: '请输入平台简称', trigger: 'blur' }
        ],
        invoicePlatformCode: [
          { required: true, message: '请输入平台编码', trigger: 'blur' }
        ],
        invoicePrivateKey: [
          { required: true, message: '请输入私钥', trigger: 'blur' }
        ],
        invoicePublicKey: [
          { required: true, message: '请输入公钥', trigger: 'blur' }
        ],
        invoiceTaxpayerNum: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
        ],
        invoiceTaxRate: [
          { required: true, message: '请输入税率', trigger: 'blur' }
        ],
        invoiceTaxClassificationCode: [
          { required: true, message: '请输入税收分类编码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    var that = this;
    fetchShopConfigDetail({}).then((res) => {
      if (res.errorCode === '0000') {
        let data = res.data
        that.ruleForm.invoiceDomain = data.invoiceDomain
        that.ruleForm.invoiceDesKey = data.invoiceDesKey
        that.ruleForm.invoicePlatformAlias = data.invoicePlatformAlias
        that.ruleForm.invoicePlatformCode = data.invoicePlatformCode
        that.ruleForm.invoicePrivateKey = data.invoicePrivateKey
        that.ruleForm.invoicePublicKey = data.invoicePublicKey
        that.ruleForm.invoiceTaxpayerNum = data.invoiceTaxpayerNum
        that.ruleForm.invoiceTaxRate = data.invoiceTaxRate
        that.ruleForm.invoiceTaxClassificationCode = data.invoiceTaxClassificationCode
      }
    })
  },
  methods: {
    // 保存操作
    saveBtn () {
      let that = this
      let invoiceDomain = that.ruleForm.invoiceDomain
      let invoiceDesKey = that.ruleForm.invoiceDesKey
      let invoicePlatformAlias = that.ruleForm.invoicePlatformAlias
      let invoicePlatformCode = that.ruleForm.invoicePlatformCode
      let invoicePrivateKey = that.ruleForm.invoicePrivateKey
      let invoicePublicKey = that.ruleForm.invoicePublicKey
      let invoiceTaxpayerNum = that.ruleForm.invoiceTaxpayerNum
      let invoiceTaxRate = that.ruleForm.invoiceTaxRate
      let invoiceTaxClassificationCode = that.ruleForm.invoiceTaxClassificationCode
      if(invoiceDomain == ''){
        this.$message.error('请输入开票接口地址')
        return false
      }
      if(invoiceDesKey == ''){
        this.$message.error('请输入3DES密钥')
        return false
      }
      if(invoicePlatformAlias == ''){
        this.$message.error('请输入平台简称')
        return false
      }
      if(invoicePlatformCode == ''){
        this.$message.error('请输入平台编码')
        return false
      }
      if(invoicePrivateKey == ''){
        this.$message.error('请输入私钥')
        return false
      }
      if(invoicePublicKey == ''){
        this.$message.error('请输入公钥')
        return false
      }
      if(invoiceTaxpayerNum == ''){
        this.$message.error('请输入纳税人识别号')
        return false
      }
      if(invoiceTaxRate == ''){
        this.$message.error('请输入税率')
        return false
      }
      if(invoiceTaxClassificationCode == ''){
        this.$message.error('请输入税收分类编码')
        return false
      }
      let passData = {
        invoiceDomain:invoiceDomain,
        invoiceDesKey:invoiceDesKey,
        invoicePlatformAlias:invoicePlatformAlias,
        invoicePlatformCode:invoicePlatformCode,
        invoicePrivateKey:invoicePrivateKey,
        invoicePublicKey:invoicePublicKey,
        invoiceTaxpayerNum:invoiceTaxpayerNum,
        invoiceTaxRate:invoiceTaxRate,
        invoiceTaxClassificationCode:invoiceTaxClassificationCode
      }
      that.fullscreenLoading = true
      saveOrUpdateShopConfig(passData).then((res) => {
         that.fullscreenLoading = false
         that.backDataFun(res)
      });
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(0)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/setting/components/Invoice.vue